<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("menu.corporate") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <router-link
            :to="{ name: 'corporate_create' }"
            class="text-light"
            v-if="isDtacAdmin"
          >
            <base-button size="md" type="neutral">{{ $t("new") }}</base-button>
          </router-link>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ $t("menu.corporate") }}</h3>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column
                min-width="200px"
                align="right"
                :label="$t('actions')"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <router-link
                    :to="{
                      name: 'agent_number',
                      query: { id: row.ID, name: row.Name }
                    }"
                    color="white"
                  >
                    <base-button class="edit" type="warning" size="sm" icon>
                      Voicemail
                    </base-button>
                  </router-link>
                  <router-link
                    :to="{
                      name: 'agent_number',
                      query: { id: row.ID, name: row.Name }
                    }"
                    color="white"
                  >
                    <base-button class="edit" type="warning" size="sm" icon>
                      {{ $t("menu.number") }}
                    </base-button>
                  </router-link>

                  <router-link
                    :to="{
                      name: 'mlhg',
                      query: { id: row.ID, name: row.Name }
                    }"
                    color="white"
                  >
                    <base-button
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                      v-if="isReadOnly"
                    >
                      {{ $t("mlhg.name") }}
                    </base-button>
                  </router-link>

                  <base-button
                    v-if="isDtacAdmin"
                    @click.native="handleEdit($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-edit"></i>
                  </base-button>
                  <base-button
                    v-if="isDtacAdmin"
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('menu.corporate')"
          input-classes="form-control-alternative new-event--title"
          v-model="edit_name"
        >
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      // tableData: "Corporate/getData"
    }),
    tableData: function(){
      return [
        {
          ID : 1,
          Name : "Corporate A",
          Brn : "123456",
        }
      ]

    },
    tableColumns: function() {
      return [
        {
          prop: "Name",
          label: this.$t("menu.corporate"),
          minWidth: 160,
          sortable: false
        },
        {
          prop: "Brn",
          label: this.$t("brn"),
          sortable: false
        }
        // {
        //   prop: "Code",
        //   label: this.$t("code"),
        //   minWidth: 220,
        //   sortable: false
        // }
      ];
    }
  },
  mounted() {
    // this.listData();
  },
  data() {
    return {
      propsToSearch: ["name"],

      // tableData: users,
      selectedRows: [],
      showAddModal: false,
      rowEdit: {},
      edit_name: ""
    };
  },
  methods: {
    ...mapActions({
      createData: "Corporate/createData",
      updateData: "Corporate/updateData",
      deleteData: "Corporate/deleteData",
      listData: "Corporate/listData"
    }),
    handleEdit(index, row) {
      this.rowEdit = row;
      this.showAddModal = true;
      this.edit_name = this.rowEdit.Name;
    },
    handleUpdate() {
      this.showAddModal = false;
      this.rowEdit.Name = this.edit_name;
      this.updateData({
        id: this.rowEdit.ID,
        newName: this.rowEdit.Name
      })
        .then(resp => {
          this.listData();
          swal.fire({
            title: this.$t("edit_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              id: row.ID
            })
              .then(resp => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style scoped>
.btn {
  margin: 2px;
}
.no-border-card .card-footer {
  border-top: 0;
}
</style>
